var path = 'src/app/components/common/query-param-guard/query-param-guard.template.html';
var html = "<div ng-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;